import React, { useRef, useState } from "react";
import { Form, Schema, Input } from "rsuite";
import styled from "styled-components";

import { useWindowWidth } from "hooks";
import { api } from "api/loginRoutes";
import CustomField from "components/Form/CustomField";
import Modal from "components/Modal";

const { StringType } = Schema.Types;


const ModalAddNewPrice = ({
    supplierId,
    onClose,
    onSuccess,
    pickedSupplierPrice
}) => {

    const formRef = useRef(null);
    const [disabled, setDisabled] = useState(false);
    const [extraDisabled, setExtraDisabled] = useState(false);

    const onSubmit = async () => {
        if (!formRef.current.check())
            return;

        const data = { ...formRef.current.getFormValue() };

        setDisabled(true);

        const method = "sms.supplier_price:create";
        const params = {
            target: {
                "sms.supplier_id": supplierId,
                "sms.supplier_price_id": pickedSupplierPrice?.id,
            },
            ...data,
            type: "transit"
        };

        const result = await api(method, params);

        setDisabled(false);

        if (result) {
            onSuccess();
        }
    };

    return (
        <Modal
            show
            title="Add new price"
            onClose={onClose}
            onSuccess={onSubmit}
            successText="Create"
            extraDisabled={extraDisabled}
            width={520}
            footer
        >
            <ModalForm
                formRef={formRef}
                disabled={disabled}
                setExtraDisabled={setExtraDisabled}
            />
        </Modal>
    );
};

export default ModalAddNewPrice;

const ModalForm = ({
    formRef,
    disabled = false
}) => {
    const defaultFormValue = {
        supplier_price_name: ""
    };

    const [formState, setFormState] = useState(defaultFormValue);
    const windowWidth = useWindowWidth();

    const formModel = Schema.Model({
        name: StringType()
            .isRequired("Required")
            .minLength(3, "Too short")
            .maxLength(40, "Too long")
    });

    return (
        <Form
            ref={formRef}
            layout="inline"
            model={formModel}
            formValue={formState}
            formDefaultValue={{ ...defaultFormValue }}
            onChange={(formValue) => {
                setFormState(formValue);
            }}
        >
            <StyledGroupContainer>
                <CustomField
                    accepter={Input}
                    disabled={disabled}
                    placeholder="Price name..."
                    label="Price"
                    name="name"
                    width={230}
                />
            </StyledGroupContainer>
        </Form>
    );
};

const StyledGroupContainer = styled.div`
    && {
        display: inline;

        .rs-form-group {
            margin-left: 15px;
            margin-bottom: 20px;
        }
    }
`;